{{
  'page.shift_timeline.assign_shift.bulk_access_rights.description' | translate
}}

<ng-container *nzModalFooter>
  <button nz-button (click)="handleCancel()">
    {{ 'general.cancel' | translate }}
  </button>

  <button nz-button (click)="handleProceedAnyway()">
    {{
      'page.shift_timeline.assign_shift.access_rights.proceed_anyway'
        | translate
    }}
  </button>

  <button
    nz-button
    nzType="primary"
    nz-tooltip
    [nzTooltipTitle]="
      'page.shift_timeline.assign_shift.access_rights.update_shift.tooltip'
        | translate
    "
    (click)="handleUpdateShifts()"
  >
    {{
      'page.shift_timeline.assign_shift.bulk_access_rights.update_shifts'
        | translate
    }}
  </button>
</ng-container>
